import axios from "axios";

const HistoriAPI = {
  getAllNotifPagination: async ({
    token,
    employee,
    currentPage = 1,
    projectPerPage,
    type = "",
    admin = false,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/notification?employeeId=${employee}&currentPage=${currentPage}&pageSize=${projectPerPage}&type=${type}&admin=${admin}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllNotifPaginationDashboard: async ({
    token,
    employee,
    currentPage = 1,
    projectPerPage,
    type = "",
    admin = false,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/notification-dashboard?employeeId=${employee}&currentPage=${currentPage}&pageSize=${projectPerPage}&admin=${admin}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getReservasiMejaByNo: async ({ token, reservationNo }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/reservation/${reservationNo}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getReservasiPaketByNo: async ({ token, reservationNo }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/reservationpackage/${reservationNo}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getDetailNotif: async ({ token, notifId, employee_id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/notification/detailNotif/${notifId}?employeeId=${employee_id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  readNotif: async ({ token, notifId, type }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/notification/readNotif/${notifId}?type=${type}`,
      {},
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  checkNotif: async ({ token, notifId, action = "SUDAH DICEK" }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/notification/checkNotif/${notifId}?action=${action}`,
      {},
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  changeSPV: async ({ token, notifId, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/notification/changeSPV/${notifId}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
};

export default HistoriAPI;
